import React from 'react'
import PropTypes from 'prop-types'
import PublicNavbar from 'components/PublicNavbar'
import PublicFooter from 'components/PublicFooter'
import HowCanWeHelpYouSection from 'components/sections/HowCanWeHelpYouSection'
import useBodyClasses from 'data/hooks/useBodyClasses'
import MobilePublicNavbar from 'components/mobile/MobilePublicNavbar'
import { useScreenWidth } from 'data/hooks/useScreenWidth'
import CenteredCustomerLoginModal from 'components/modals/getHelp/CenteredCustomerLoginModal'
import { setCenteredLoginModalOpen, setLoginModalOpen, setRegisterModalOpen } from 'store/auth'
import { useDispatch, useSelector } from 'react-redux'
import CustomerLoginModal from 'components/modals/CustomerLoginModal'
import CustomerRegisterModal from 'components/modals/CustomerRegisterModal'

const PublicLayout = ({ children }) => {
  const { isMobile } = useScreenWidth(1024)
  const dispatch = useDispatch()

  const { loginModalOpen, centeredModalOpen, registerModalOpen } = useSelector(state => ({
    loginModalOpen: state.auth.loginModalOpen,
    centeredModalOpen: state.auth.centeredLoginModalOpen,
    registerModalOpen: state.auth.registerModalOpen,
  }))
  useBodyClasses('font-sans', 'overflow-x-hidden')
  return (
    <>
      <div className="min-h-[145px] lg:min-h-[137px]">
        {isMobile ? <MobilePublicNavbar /> : <PublicNavbar />}
      </div>
      {children}
      <CenteredCustomerLoginModal
        modalOpen={centeredModalOpen}
        onClose={() => dispatch(setCenteredLoginModalOpen(false))}
      />

      <CustomerLoginModal
        isOpen={loginModalOpen}
        onClose={() => dispatch(setLoginModalOpen(false))}
      />

      <CustomerRegisterModal
        isOpen={registerModalOpen}
        onClose={() => dispatch(setRegisterModalOpen(false))}
      />

      <HowCanWeHelpYouSection />
      <PublicFooter />
    </>
  )
}

PublicLayout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default PublicLayout
